<template>
  <div class="main">
    <div class="title">
      <div class="name">预约信息</div>
      <div class="numbox">
        <p>预约总数<b>{{yuyue_all_count}}</b></p>
        <span>|</span>
        <p>待处理<b>{{yuyue_count}}</b></p>
      </div>
    </div>
    <div class="box">
      <div class="search-box">
        <div class="input-box">
          <el-input v-model="input" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
          <div @click="List">
            <i class="iconfont icon-sousuo"></i>
            <span>搜索</span>
          </div>
        </div>
      </div>
      <div class="tabs">
        <el-radio-group v-model="tabPosition" @change="tabChange" style="margin-bottom: 20px;">
          <el-radio-button :label="1">内部预约</el-radio-button>
          <el-radio-button :label="2">外部预约</el-radio-button>
          <el-radio-button :label="3">我的预约</el-radio-button>
        </el-radio-group>
      </div>
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="item-detail">
            <div class="img">
              <img :src="urlStr + item.qpic" alt="">
            </div>
            <div class="cont">
              <div class="name">
                <b>{{item.qname}}</b>
                <span class="s3" v-if="Number(item.status) === 1 && tabPosition == 2">已处理</span>
                <span class="s3" v-if="item.evaluate != '' && tabPosition == 3">已评价</span>
              </div>
              <div class="lyu ovHide">{{item.qtype | type}}</div>
              <div class="yueren">
                <span>预约人：{{item.name}}</span>
              </div>
            </div>
          </div>
          <div class="text">
            <span>申请时间：</span>
            <span>{{item.create_time}}</span>
          </div>
          <div class="text">
            <span>联系电话：</span>
            <span>{{item.phone}}</span>
          </div>
          <div class="text height">
            <span>{{tabPosition == 2 ? '申请内容' : '项目名称'}}：</span>
            <span class="ovHide2">{{tabPosition == 2 ? item.content : item.project_name}}</span>
          </div>
          <div class="flex justify-center align-center btnbox">
            <span class="s1" v-if="Number(item.status) === 0" @click="changeFun(item.id)">处理</span>
            <span class="s1" v-if="tabPosition != 2" @click="toDetail(item.id,item.qid)">详情</span>
            <span class="s1" v-if="Number(item.status) === 1" @click="del(item.id)">删除</span>
            <span class="s1" v-if="tabPosition == 3 && Number(item.is_evaluate) === 1" @click="toE(item.id)">评价</span>
            <span class="s1 width" v-if="tabPosition == 3 && item.evaluate" @click="look(item)">查看评价</span>
          </div>
        </div>
        <el-empty :image-size="200" v-if="list.length == 0" style="margin: 0 auto"></el-empty>
        <div class="page-box" v-else>
          <el-pagination
            :current-page.sync="page"
            :page-size="limit"
            :total="total"
            background
            class="page-all margin-top self-end"
            layout="prev, pager, next"
            @current-change="List">
          </el-pagination>
        </div>
      </div>
    </div>

    <evaluateDialog :dialogVisible="dialogVisible" :pjId="pjId" :item="item" @handleClose="handleClose" />
  </div>
</template>
<script>
import {
  changeStatus,
  delYuyue,
  yuyueList,
  myInternalIndex,
  internalIndex,
  getExpertType, delInternalYuyue
} from "@/api/index";
import {urlStr} from "@/config";
import evaluateDialog  from "@/views/home/common/evaluateDialog";
let that;
export default {
  name: "reservation",
  data() {
    return {
      urlStr: urlStr,
      dialogVisible: false,
      tabPosition: 1,
      input:'',
      item:{},
      options:[],
      list:[],
      yuyue_all_count:'',
      yuyue_count:'',
      page:1,
      limit:12,
      total:0,
      pjId:'',
      score: 0,
      evaluate:'',
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {evaluateDialog},
  beforeCreate() {
    that = this
  },
  created() {
    this.$emit("setActive", {
      active: 1,
      act: 4,
      name: '专家管理 > 预约信息'
    })
    this.getExpertType()
    this.List()
  },
  methods: {
    handleClose(){
      this.dialogVisible = false
      this.pjId = ''
      this.score =  0
      this.evaluate = ''
      this.List()
    },

    tabChange(){
      this.page = 1
      this.List()
    },

    // 去评价
    toE(id){
      this.dialogVisible = true
      this.pjId = id
    },

    // 查看评价
    look(item){
      this.dialogVisible = true
      this.item = item
      this.dialogVisible = true
    },

    // 获取列表
    async List() {
      let _res;
      let data = {mid:this.user.mid,
        search_name:this.input,
        page:this.page,limit:this.limit} ;
      if(this.tabPosition == 1) {
         _res = await internalIndex(data);
      }
      if(this.tabPosition == 2) {
        _res = await yuyueList(data);
      }
      if(this.tabPosition == 3) {
        _res = await myInternalIndex(data);
      }
      if (_res.status === 200) {
        this.list = _res.data.list
        this.total = _res.total_number
        this.yuyue_count = _res.data.yuyue_count
        this.yuyue_all_count = _res.data.yuyue_all_count
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 获取专家领域
    async getExpertType(){
      let _res = await getExpertType(
        this.user.mid
      );
      if(_res.status === 200){
        this.options = _res.data
      }else {
        this.$message.error(_res.msg);
      }
    },

    async changeFun(id){
      let _res = await changeStatus(
          this.user.mid,id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.List()
      } else {
        this.$message.error(_res.msg)
      }
    },
    del(id){
      this.tabPosition == 2 ? this.delFun(id) : this.delInternalFun(id)
    },
    // 删除预约 外部
    async delFun(id){
      let _res = await delYuyue(
          this.user.mid,id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.List()
      } else {
        this.$message.error(_res.msg)
      }
    },
    // 删除预约 内部
    async delInternalFun(id){
      let _res = await delInternalYuyue(
        this.user.mid,id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.List()
      } else {
        this.$message.error(_res.msg)
      }
    },
    toDetail(id,qid){
      this.$router.push({
        path: '/home/examineYuyue',
        query:{
          detailId:id,
            id:qid,
        }
      })
    },

  },
  watch: {

  },
  filters: {
    type(type){
      let name;
      that.options.map(item => {
        if (item.id == type) {
          name = item.name
        }
      })
      return name
    },
  }
}
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  .title {
    padding: 5px 15px 15px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .numbox {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      span {
        color: #ffffff;
        opacity: 0.3;
        margin: 0 40px;
      }
      p {
        font-size: 18px;
        color: #ffffff;
        display: flex;
        align-items: center;
        b {
          font-size: 27px;
          color: #ff9600;
          margin-left: 20px;
        }
      }
    }
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }
  .box {
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    background-color: #ffffff;
    flex: 1;
    .search-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .input-box {
        flex: 1;
        width: 0;
        display: flex;
        height: 40px;
        overflow: hidden;
        justify-content: space-between;
        border-radius: 5px;

        > div {
          width: 100px;
          height: 40px;
          background-color: #0a2240;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 16px;
            color: #ffffff;
          }
          i {
            margin-right: 4px;
            color: #ffffff;
            font-size: 18px;
          }
        }
      }
    }
    .list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-top: 20px;
      min-height: 500px;
      .item {
        width: 305px;
        height: 280px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #dae0e6;
        margin-right: 20px;
        margin-bottom: 20px;
        padding: 15px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .item-detail {
          display: flex;
          justify-content: space-between;
          padding-bottom: 6px;
          .img {
            width: 76px;
            height: 99px;
            background-color: #eaeff3;
            border-radius: 10px;
            margin-right: 10px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: scale-down;
            }
          }
          .cont {
            flex: 1;
            width: 0;
            border-bottom: 1px solid #dae0e6;
            .name {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              b {
                font-size: 18px;
                color: #333333;
                font-weight: bold;
              }
              .s1 {
                display: block;
                width: 70px;
                height: 30px;
                background-color: #0a2240;
                border-radius: 15px;
                text-align: center;
                line-height: 28px;
                font-size: 14px;
                letter-spacing: 1px;
                color: #ffffff;
                cursor: pointer;
                margin-left: 4px;
              }
              .s2 {
                display: block;
                width: 70px;
                height: 30px;
                border: 1px solid #0a2240;
                border-radius: 15px;
                text-align: center;
                line-height: 28px;
                font-size: 14px;
                letter-spacing: 1px;
                color: #0a2240;
                cursor: pointer;
                margin-left: 2px;

              }
              .s3 {
                font-size: 14px;
                color: #999999;
              }
            }
            .lyu {
              width: 100%;
              font-size: 14px;
              color: #333333;
              margin: 10px 0;
              height: 20px;
            }
            .yueren {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .s1 {
                font-size: 14px;
                color: #333333;
              }

            }
          }
        }
        .btnbox {
          width: 100%;
          margin-top: 10px;
          .s1 {
            display: block;
            width: 70px;
            height: 30px;
            background-color: #0a2240;
            border-radius: 15px;
            text-align: center;
            line-height: 28px;
            font-size: 14px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;
            margin: 0 5px;
            &.width {
              width: 80px;
            }
          }
          .s2 {
            display: block;
            width: 70px;
            height: 24px;
            border: 1px solid #0a2240;
            border-radius: 12px;
            text-align: center;
            line-height: 22px;
            font-size: 14px;
            letter-spacing: 1px;
            color: #0a2240;
            cursor: pointer;
            margin: 0 5px;
          }
        }
        .text {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 10px;
          &.height {
            height: 40px;
          }
          span:first-child {
            width: 75px;
            font-size: 14px;
            color: #666666;
          }
          span:last-child {
            flex: 1;
            width: 0;
            font-size: 14px;
            color: #666666;
          }
        }
      }
    }
  }
}
</style>


